/*
 * Copyright 2025 ixPilot Teknoloji A.Ş.
 * Tüm hakları saklıdır.
 */

import { Box, Text, Flex } from "@chakra-ui/react";
import { getContextMenuPosition } from "utils/contextMenuPosition";

function PotansiyelMusteriContextMenu({
  position,
  data,
  onClose,
  onEdit,
  onEndProcess,
  onStageChange,
  onShowHistory,
}) {
  if (!position) return null;
  const menuPosition = getContextMenuPosition(position, { menuWidth: 230, menuHeight: 220 });

  return (
    <Box
      position="fixed"
      top={`${menuPosition.y}px`}
      left={`${menuPosition.x}px`}
      bg="white"
      borderRadius="lg"
      shadow="0 4px 12px rgba(0, 0, 0, 0.15)"
      zIndex={2000}
      onMouseLeave={onClose}
      minW="180px"
      fontSize="11px"
      py={1}
    >
      <MenuItem label="Bilgileri Düzenle" onClick={() => { onEdit?.(data); onClose(); }} />
      <MenuItem
        label="Süreç Sonlandır + Not"
        isDestructive
        onClick={() => { onEndProcess?.(data); onClose(); }}
      />
      <MenuItem
        label="Dönüş Ekle"
        onClick={() => { onStageChange?.(data); onClose(); }}
      />
      <MenuItem
        label="Dönüş Geçmişi"
        onClick={() => { onShowHistory?.(data); onClose(); }}
      />
    </Box>
  );
}

function MenuItem({ label, onClick, isDestructive = false }) {
  return (
    <Flex
      align="center"
      px={3}
      py={1.5}
      cursor="pointer"
      borderRadius="md"
      mx={1}
      transition="all 0.15s ease"
      _hover={{
        bg: isDestructive ? "red.50" : "gray.50",
        color: isDestructive ? "red.600" : "gray.900",
        transform: "scale(1.02)",
      }}
      onClick={onClick}
    >
      <Text
        fontWeight="500"
        color={isDestructive ? "red.500" : "gray.600"}
        fontSize="11px"
      >
        {label}
      </Text>
    </Flex>
  );
}

export default PotansiyelMusteriContextMenu;


